<template>
  <div>
    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 40}" v-model="msg" placeholder="1000字以内"/>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updateApplyStatus} from "@/api/url";

export default {
  name: "UpdateApplyStateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      state: this.value.state,
      msg: this.value.state == 2?'恭喜，你的达人申请已通过，请前往“首页->顶部【达人排行榜】图标”查看最新的奖品情况！':this.value.state == 3?'你的达人申请未能通过审核，请保持足够的活跃度之后，再提交申请': '',
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      if ( !this.msg ) {
        this.$message({
          message: '通知内容不能为空',
          duration: 2000,
          type: 'warning'
        })
        return  false
      }
      this.loading = true
      let param = {}
      param['idArr'] = this.idArray
      param['status'] = this.state
      param['msg'] = this.msg
      postFormData(updateApplyStatus, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }

  }
}
</script>

<style scoped>

</style>
